import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

function isOk(field) {
    return field === undefined;
}

function min0max100(score) {
    return !(score === undefined || (0 <= score && score <= 100));
}

function helperText(field, intl) {
    return field === undefined || field.length === 0 ? intl.formatMessage({ id: 'required' }) : '';
}

function min0max100Text(score, intl) {
    return min0max100(score) ? intl.formatMessage({ id: 'min0max100' }) : '';
}

class Item extends React.Component {
    state = {
        nombre: this.props.item ? this.props.item.valor : '',
        score:
            this.props.item && this.props.item.puntuacion
                ? this.props.item.puntuacion.toString()
                : '',
    };

    handleClick = (id) => (event) => {
        this.setState({ score: id });
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleClose = (name, score) => (event) => {
        this.props.handleClose(name, score);
    };

    isCorrect = () => {
        const { nombre } = this.state;
        return nombre && nombre.length > 0 ? true : false;
    };

    render() {
        const { nombre, score } = this.state;
        const { intl } = this.props;
        return (
            <Dialog
                open={true}
                onClose={this.handleClose(null, null)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent className={'padding_borders'}>
                    <TextField
                        autoFocus
                        fullWidth
                        id={'nombre'}
                        name={'nombre'}
                        required
                        error={isOk(nombre)}
                        helperText={helperText(nombre, intl)}
                        label={intl.formatMessage({ id: 'form_field_name_nombre' })}
                        className={'flex_full_row'}
                        value={nombre}
                        onChange={this.handleChange}
                        margin="normal"
                    />
                    <TextField
                        id="score"
                        name="score"
                        fullWidth
                        label={intl.formatMessage({ id: 'percentage' })}
                        className={'flex_full_row'}
                        value={score}
                        onChange={this.handleChange}
                        error={min0max100(score)}
                        helperText={min0max100Text(score, intl)}
                        margin="normal"
                        type="number"
                        inputProps={{ pattern: '[0-9]*' }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose(null, null)} color="primary">
                        <FormattedMessage id="cancel" />
                    </Button>
                    <Button
                        onClick={this.handleClose(nombre, score)}
                        color="primary"
                        autoFocus
                        disabled={!this.isCorrect()}
                    >
                        <FormattedMessage id="accept" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

Item.propTypes = {
    intl: intlShape.isRequired,
};

Item = injectIntl(Item);

export default Item;



// WEBPACK FOOTER //
// ./src/components/complex/manage/catalog/Item.js